import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ProfileDialogComponent } from "../profile-dialog/profile-dialog.component";
import { CommunService } from "../commun.service";
import { GroupService } from "../group.service";
import { HttpClient } from "@angular/common/http";
import { ConfigureService } from "service/ng4-configure/ng4-configure.service";
import { VersionInfos } from "model/collection";
import { forkJoin, of, Subscription } from "rxjs";
import { catchError, map } from "rxjs/operators";
import pkg from "../../../../package.json";
import { NavigationEnd, Router } from "@angular/router";
import { MOSAR_URL } from "app/app-routing.module";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public versions: any = [];
  public profile: any = {};
  MOSAR_URL = MOSAR_URL;
  groups = [];

  versionInfos = new VersionInfos();
  sub: Subscription = new Subscription();
  docBaseUrl = "http://documentation-url/";
  section = "scenario";

  isSelectedMenuSystemproof= false;
  isSelectedMenuScenario = false;
  isSelectedMenuCollection = false;

  constructor(
    private keycloakService: KeycloakService,
    private modalService: NgbModal,
    public service: CommunService,
    private groupService: GroupService,
    private http: HttpClient,
    public configService: ConfigureService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event.url;
        if(url === "/") {
          url = event.urlAfterRedirects;
        }
        if (url.includes("testprotocol")) {
          this.section = "testprotocol";
        } else if (url.includes("usecase")) {
          this.section = "usecase";
        } else {
          this.section = "scenario";
        }
        this.updateCurrentSelectedSection(url)
        this.keycloakService.isLoggedIn().then((isLoggedIn: boolean) => {
          if (isLoggedIn) {
            this.loadIdentity();
            this.groupService
              .getAdministrablesGroups()
              .subscribe((groups) => (this.groups = groups));
          }
        });
      };
    });    

    this.docBaseUrl = this.configService.config.documentationUrl;

    this.sub.add(
      forkJoin([
        this.configService.getVersions().pipe(
          map((resp) => resp),
          catchError((err) => of([]))
        ),
        this.http.get<any>("/assets/config.json").pipe(
          map((resp) => resp.apiUrl),
          catchError((err) => of(""))
        ),
        this.http.get<any>("/assets/keycloak.json").pipe(
          map((resp) => resp["auth-server-url"]),
          catchError((err) => of(""))
        ),
      ]).subscribe(([versions, apiUrl, authUrl]) => {
        this.versionInfos.dashboardVersion = pkg.version;
        this.versionInfos.statisticsVersion =
          pkg.dependencies["@MOSAR/mosar-statistics-dashboard"];

        const apiVersion =
          versions.find(
            (version) => version.name === "mosar-scenariomanager-interface"
          )?.version || "Not found";
        const backendVersion =
          versions.find(
            (version) => version.name === "mosar-scenariomanager-impl"
          )?.version || "Not found";
        this.versionInfos.datamodelVersion = apiVersion;
        this.versionInfos.apiVersion = apiVersion;
        this.versionInfos.backendVersion = backendVersion;
        this.versionInfos.apiUrl = apiUrl;
        this.versionInfos.authUrl = authUrl;
      })
    );
  }

  private updateCurrentSelectedSection(currentPath: string) {
    this.isSelectedMenuScenario = false;
    this.isSelectedMenuSystemproof = false;
    this.isSelectedMenuCollection = false;
    if (currentPath.includes(MOSAR_URL.SCENARIO_MANAGER)) {
      this.isSelectedMenuScenario = true;
    } else if (
      currentPath.includes(MOSAR_URL.SYSTEM_PROOF) 
    ) {
      this.isSelectedMenuSystemproof = true;
    } else if (currentPath.includes(MOSAR_URL.FRAME_OF_REFERENCE)) {
      this.isSelectedMenuCollection = true;
    }
    this.cdr.detectChanges();
  }

  public logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.keycloakService.logout();
  }

  public openProfileDialog() {
    const modalRef = this.modalService.open(ProfileDialogComponent);
    modalRef.componentInstance.profile = this.profile;
  }

  private loadIdentity() {
    const keycloakInstance = this.keycloakService.getKeycloakInstance();

    this.keycloakService.loadUserProfile().then((profile) => {
      this.profile = profile;
      if (keycloakInstance && keycloakInstance.tokenParsed)
        this.profile.groups = keycloakInstance.tokenParsed["groups"];
    });
  }
}
